<template>
  <!--button type="button">{{ props.name }}</button>-->
  <div class="container">
    <FormInput :name="columnName" v-model="searchText" :placeHolder="'type to filter'"></FormInput>
    <div class="btn-div">
      <SvgButton @clicked="$emit('sortAsc', columnName)" :svg_name="'chevron_down'"></SvgButton>
      <SvgButton @clicked="$emit('sortDesc', columnName)" :svg_name="'chevron_up'"></SvgButton>
    </div>
    <!-- <FormBtn :name="'sort asc'" @clicked="$emit('sortAsc',columnName)"></FormBtn>
    <FormBtn :name="'sort desc'" @clicked="$emit('sortDesc',columnName)"></FormBtn>-->
  </div>
  <!--div class="debug">
        <p>columnName = {{ columnName }}</p>
        <p>searchText = {{ searchText }}</p>
    </div>-->
</template>

<script setup lang="ts">
//import { ref, computed, watch } from 'vue';
import { FormInput, FormBtn } from '@/components'
import SvgButton from '@/components/buttons/svg-button.vue'

const props = defineProps({
  //name : { type: String},
  //tableData: { type: Array },
  columnName: { type: String }
})

const emit = defineEmits(['sortAsc', 'sortDesc'])

//const searchText = ref('');
const searchText = defineModel<string>('searchText')
//const filtered = defineModel<Array<any>>('filtered', {default: ['']});
/*
watch(() => searchText.value, (newVal, oldVal) => {
   // console.log("watch called on searchText.value = " + newVal);
    filtered.value = props.tableData.filter(row => row[props.columnName].toString().toLowerCase().includes(newVal.toLowerCase()));
}); //, { deep: true });
*/
/*
const filtered = computed(()=>{
    return props.tableData.filter(row => row[props.columnName].toString().toLowerCase().includes(searchText.value.toLowerCase()));
});
*/
</script>

<style lang="css" scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: start;
}

.button-div {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
}

.dropdown {
  position: relative;
  display: inline-block;
  width: 100%;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: white;
  min-width: 4rem;
  box-shadow: 0px 8px 16px 0px rgba(0x0x0x0.2);
  padding: 1rem 1rem;
  z-index: 1;
}

.dropdown:hover .dropdown-content {
  display: block;
}
span {
  display: block;
  width: 100%;
  color: yellow;
}
</style>
